import { createContext, useContext } from 'react';

import type { ApolloError } from 'apollo-client';

import type { MyLearning_SkillPathwayFragment as SkillPathway } from 'bundles/unified-home-common/queries/__generated__/EnterpriseGetAllSkillPathways';

export type EnterpriseAllSkillPathwaysContextType = {
  skillPathways: Array<SkillPathway>;
  loading: boolean;
  error?: ApolloError;
};

// This API will return information for all skill pathways in a given program.
// Skill pathways are a special kind of learning path/badge. This API returns data specifically relating to the skills content within a skill pathway.
// We compare the IDs of items returned here to the response for learning paths/badge collections to determine which learning paths/badges
// should be considered "skill pathways".
export const EnterpriseAllSkillPathwaysContext = createContext<EnterpriseAllSkillPathwaysContextType>({
  skillPathways: [],
  loading: false,
  error: undefined,
});

export const useEnterpriseAllSkillPathways = () => useContext(EnterpriseAllSkillPathwaysContext);

export default EnterpriseAllSkillPathwaysContext;
